import React, { useState } from "react";
import { View } from "@tarojs/components";
import classNames from "classnames";
import { pxTransform } from "@/utils";

import "./index.scss";

type RankProps = {
  defalutScore?: number;
  onChange: (rank: number) => void;
  max?: number;
  size?: number;
  tip?: string;
  style?: React.CSSProperties & {
    "--color-primary": string;
  };
};

const Rank: React.FC<RankProps> = props => {
  const {
    defalutScore = -1,
    onChange,
    max = 5,
    size = 0,
    tip = "轻点星形以评分",
    style = {},
  } = props;
  const [score, setScore] = useState(defalutScore);

  const selectRank = (index: number) => {
    setScore(index);
    onChange?.(index + 1);
  };

  return (
    <View
      className={classNames("xh-rank")}
      style={size ? { fontSize: pxTransform(size), ...style } : { ...style }}
    >
      <View className="xh-rank-tip">{tip}</View>
      <View className="xh-rank-star">
        {Array(max)
          .fill(1)
          .map((_item, index) => (
            <View
              key={index}
              className={classNames("xh-rank-star-active", {
                active: index <= score,
              })}
              onClick={() => selectRank(index)}
            ></View>
          ))}
      </View>
    </View>
  );
};

export default Rank;
